<template>
<div class="info-field">
  <div class="info-field__label">{{ label }}</div>
  <div class="info-field__data">
    <div
      v-if="text"
      :class="{'info-field__text_deprecated': textIsDeprecated}"
      class="info-field__text">{{ text }}</div>
    <dots-spinner class="dots-spinner" v-if="loading" />
  </div>
</div>
</template>

<script>
export default {
  props: {
    text: String,
    label: {
      type: String,
      required: true,
    },
    loading: Boolean,
    hasError: Boolean,
  },
  computed: {
    textIsDeprecated() {
      return this.loading || this.hasError;
    },
  },
};
</script>

.<style lang="scss" scoped>
.info-field {
  &__label {
    @include label;
    margin-bottom: 16px;
  }
  &__text {
    font-size: 21px;
    &_deprecated {
      opacity: 0.4;
    }
    margin-right: 15px;
  }
  &__data {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/uikit/InfoField.vue